module.exports = __webpack_public_path__ + "img/Wp_2021.03aa52fb.png";